const generalState = {
    state: {
        env: {
            isDev: null,
        },
        user: {
            id: null,
            name: null,
            shop_id: null,
            shop_list: null,
            menu: null,
            permissions: null,
            shop_name: null
        }
    },
    mutations: { 
        SET_ISDEV(state, payload) {
            state.env.isDev = (payload === 'development')
        },
        SET_USER_ID(state, payload) {
            state.user.id = payload
        },
        SET_USER_NAME(state, payload) {
            state.user.name = payload
        },
        SET_SHOP(state, payload) {
            state.user.shop_id = payload
        },
        SET_SHOP_NAME(state, payload) {
            state.user.shop_name = payload
        },
        SET_SHOPS_LIST(state, payload) {
            state.user.shop_list = payload
        },
        SET_MENU(state, payload) {
            state.user.menu = payload
        },
        SET_PERMISSIONS(state, payload) {
            state.user.permissions = payload
        }
    },
    // actions: { ... },
    // getters: { ... }
}

export default generalState;